module.exports = __webpack_public_path__ + "img/52.48c2ae64.jpg";